<script>
import { DataService } from "../../config/dataService";
import localUser from "../../js/helpers/localUser";
import store from "../../vuex/store";
const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
  props: {
    widgetId: Number,
    dataTypes: Array,
    userDataCollect: String,
    fontSize: String | Number,
    primaryColor: String,
    textColor: String,
  },
  data() {
    return {
      user: null,
    };
  },
  computed: {
    isLoading() {
      return store?.getters.isLoading;
    },

    submitDisable() {
      return !Object.values(this.user).every((item) => item !== "");
    },
  },
  methods: {
    handleSkip() {
      this.user = null;
    },
    handleChange(e) {
      this.user = { ...this.user, [e.target.name]: e.target.value };
    },
    async handleSubmit() {
      try {
        store.dispatch("startLoading");

        const { data } = await DataService.post(
          `${API_ENDPOINT}widget-user`,
          this.user
        );

        if (data) {
          localUser.setLocalUser(this.widgetId, data.id);
        }
      } catch (error) {
        console.log(
          "🚀 ~ file: UserForm.svelte:38 ~ handleSubmit ~ error:",
          error
        );

        if (error?.response?.data?.errorCode === 103) {
          return this.$toast.error("User already exist", 3000);
        }

        this.$toast.error("Something went wrong", 3000);
      } finally {
        this.user = null;
        store.dispatch("endLoading");
      }
    },
  },
  mounted() {
    this.$props.dataTypes?.map((item) => {
      this.user = { ...this.user, [item]: "" };
    });
  },
};
</script>

<template>
  <form v-if="user" class="form" @submit.prevent="handleSubmit">
    <h5 class="title">Please introduce yourself</h5>

    <input
      :style="{ fontSize: fontSize, color: textColor }"
      class="form_input"
      v-for="item of dataTypes"
      :placeholder="item"
      :name="item"
      maxLength="20"
      :value="user[item]"
      @input="handleChange"
    />

    <div class="button_box">
      <button
        @click="handleSkip"
        class="form_button"
        :style="{ background: primaryColor }"
        v-if="userDataCollect === 'optional'"
        type="button"
        on:handleClick="{handleSkipClick}"
      >
        Skip
      </button>
      <button
        :disabled="submitDisable"
        class="form_button"
        :style="{ background: primaryColor }"
        type="submit"
      >
        Send
      </button>
    </div>
  </form>
</template>

<style lang="scss" scoped>
.title {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
}

.form {
  font-family: "Inter", sans-serif;
  z-index: 99;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: 3px 9px 47px -11px rgba(0, 0, 0, 0.49);
  -webkit-box-shadow: 3px 9px 47px -11px rgba(0, 0, 0, 0.49);
  -moz-box-shadow: 3px 9px 47px -11px rgba(0, 0, 0, 0.49);
}

.button_box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
}

.form_input {
  font-family: "Inter", sans-serif;
  box-sizing: border-box;
  height: 52px;
  background: white;
  border-radius: 6px;
  padding: 0 20px;
  border: 1px solid #e7e7e7;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  outline: none;
  /* flex: 1 1 auto; */
  width: 100%;

  &::placeholder {
    font-family: "Inter", sans-serif;
  }
}

.form_button {
  border: none;
  font-family: inherit;
  font-size: 14px;
  display: inline;
  outline: none;
  border-radius: 6px;
  padding: 8px 16px;
  color: #fff;
  cursor: pointer;
  transition: all ease-in-out 300ms;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}
</style>
